import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

export default [
  {
    imgSrc:
      'https://www.nerdwallet.com/assets/blog/wp-content/uploads/2019/12/GettyImages-183815737-770x462.jpg',
    imgAlt: 'Front of a house with two windows and bicycles on the sidewalk',
    subtitle:
      'To get the best mortgage loan, know how much you can afford and shop like the bargain hunter you are.',
    title: 'How to Choose the Best Mortgage',
    description:
      'Choosing the right mortgage can help make your home buying journey easier and more affordable.',
    link: '/blog/mortgages/how-to-choose-the-best-mortgage?trk_source=mortgages_mc_mustread&trk_content=blog_howtochoosebestmort+pos_topleft&trk_destination=how-to-choose-the-best-mortgage&trk_origin=calculate-mortgage-payment&trk_app=blog',
  },
  {
    imgSrc: iconUri('Cash_back_3'),
    imgAlt: 'Wad of bills',
    title: 'Mortgage Closing Costs Explained',
    description:
      "Before you get the keys to your new home, you'll have to pay closing costs. Once you understand what they cover, they'll look less overwhelming.",
    link: '/blog/mortgages/cost-to-close-mortgage?trk_source=mortgages_mc_mustread&trk_content=blog_costtoclosemort+pos_topright&trk_destination=cost-to-close-mortgage&trk_origin=calculate-mortgage-payment&trk_app=blog',
  },
  {
    imgSrc: iconUri('Certificate'),
    imgAlt: 'Documents',
    title: 'How to Get Preapproved for a Mortgage and Why It Matters',
    description:
      "Mortgage preapproval is the smartest hack to homebuying and among the most misunderstood.​ Here's what lenders want before they'll preapprove you for a home loan.",
    link: '/blog/mortgages/preapproved-mortgage-matters?trk_source=mortgages_mc_mustread&trk_content=blog_preapprovmortmatters+pos_bottomleft&trk_destination=preapproved-mortgage-matters&trk_origin=calculate-mortgage-payment&trk_app=blog',
  },
  {
    imgSrc: iconUri('Approval'),
    imgAlt: 'Thumb up with dollar sign',
    title: 'How Much Down Payment Do You Need to Buy a Home',
    description:
      "Coming up with the cash for a down payment is the biggest roadblock for most home buyers. Here's how to know how much you really need.",
    link: '/blog/mortgages/payment-buy-home?trk_source=mortgages_mc_mustread&trk_content=blog_pmtbuyhome+pos_bottomright&trk_destination=payment-buy-home&trk_origin=calculate-mortgage-payment&trk_app=blog',
  },
];
